/**
 * titleHistory — the viewer's own record of what a thread has been called
 * (2026-09-09, Miles: a rename is personal and reflects everywhere within the
 * user's account; former names are saved for SEARCH only). Every name change
 * on the viewer's index doc — a rename, or an auto label replacing an older
 * one — appends here, oldest first, capped; nothing renders it except a
 * search hit's "was “…”".
 */
import { THREAD_TITLE_HISTORY_MAX, type ThreadTitleHistoryEntry } from '../../components/GlobalChatSystem/types';

/**
 * The history with the title about to be replaced appended as the previous
 * name of the new one. Unchanged (same reference) when nothing changes.
 */
export function appendFormerTitle(
  history: readonly ThreadTitleHistoryEntry[] | null | undefined,
  previousTitle: string | null | undefined,
  nextTitle: string | null | undefined,
  at: number = Date.now(),
): ThreadTitleHistoryEntry[] {
  const list = Array.isArray(history) ? [...history] : [];
  const prev = (previousTitle ?? '').trim();
  const next = (nextTitle ?? '').trim();
  if (!next || !prev || prev === next) return Array.isArray(history) ? (history as ThreadTitleHistoryEntry[]) : list;
  list.push({ title: next, previousTitle: prev, at });
  return list.length > THREAD_TITLE_HISTORY_MAX ? list.slice(list.length - THREAD_TITLE_HISTORY_MAX) : list;
}

/** Every former name a record has carried (titles and previous titles), minus the current one. */
export function formerTitlesOf(
  history: readonly ThreadTitleHistoryEntry[] | null | undefined,
  currentTitle: string | null | undefined,
): string[] {
  const current = (currentTitle ?? '').trim();
  const out: string[] = [];
  for (const h of Array.isArray(history) ? history : []) {
    for (const candidate of [h?.title, h?.previousTitle]) {
      const t = typeof candidate === 'string' ? candidate.trim() : '';
      if (t && t !== current && !out.includes(t)) out.push(t);
    }
  }
  return out;
}
